import React, { useCallback, useState } from "react";
import { ClickAwayListener, Collapse, createStyles, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { trackMainNavEvent } from "../../analytics";
import { SearchIcon } from "../../../../icons";
import SearchInput from "../../SearchInput";
var useStyles = makeStyles(createStyles({
    search: {
        display: "flex",
        alignItems: "center",
        height: 40,
        fontSize: 0,
        color: "#fff",
        cursor: "pointer",
        outline: "none",
        userSelect: "none",
    },
    text: {
        display: "inline-block",
        marginLeft: 8,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: 0.3,
        "&::before": {
            display: "block",
            content: "attr(data-title)",
            visibility: "hidden",
            overflow: "hidden",
            height: 0,
            fontWeight: "bold",
            letterSpacing: 0.3,
        },
    },
    open: {
        fontWeight: "bold",
        letterSpacing: "normal",
        textShadow: "0 0 #fff",
        WebkitFontSmoothing: "subpixel-antialiased",
    },
    searchBox: {
        position: "absolute",
        top: "calc(100% + 8px)",
        right: 0,
        zIndex: 1,
    },
    inputRoot: {
        width: "368px",
        height: "56px",
        padding: "0 16px",
        backgroundColor: "#010414",
        borderRadius: "8px",
    },
    input: {
        color: "#fff",
    },
}));
var Search = function (_a) {
    var config = _a.config;
    var navItem = config.navItem;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var styles = useStyles();
    var handleOpen = useCallback(function () {
        trackMainNavEvent(open ? "Close Search" : "Search");
        setOpen(!open);
    }, [open]);
    var handleClickAway = function () {
        trackMainNavEvent("Close Search");
        setOpen(false);
    };
    var handleClickInsideSearch = function (event) {
        event.stopPropagation();
    };
    return (React.createElement(ClickAwayListener, { onClickAway: handleClickAway, mouseEvent: open ? "onClick" : false, touchEvent: open ? "onTouchStart" : false },
        React.createElement("div", { className: styles.search, onClick: handleOpen, id: "headerOpenSearch" },
            React.createElement(SearchIcon, null),
            React.createElement("span", { className: clsx(styles.text, open && styles.open), "data-title": navItem }, navItem),
            React.createElement("div", { className: styles.searchBox, onClick: handleClickInsideSearch },
                React.createElement(Collapse, { in: open, timeout: 150 },
                    React.createElement(SearchInput, { classes: { root: styles.inputRoot, input: styles.input }, focus: open }))))));
};
export default Search;
